export class GetPetBreedRequest {
  petTypeCode: number

  constructor(data: any = {}) {
    this.petTypeCode = data.petTypeCode
  }
}
